import { render, staticRenderFns } from "./Dark_Room.vue?vue&type=template&id=0dabbe3d&scoped=true"
import script from "./Dark_Room.vue?vue&type=script&lang=js"
export * from "./Dark_Room.vue?vue&type=script&lang=js"
import style0 from "./Dark_Room.vue?vue&type=style&index=0&id=0dabbe3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dabbe3d",
  null
  
)

export default component.exports